<script setup lang="ts">
import { ref } from 'vue';

import VHorizontalScrollNav from '@components/scroll/VHorizontalScrollNav/VHorizontalScrollNav.vue';
import { watchImmediate } from '@vueuse/core';

import type { ReportInnerTabsMobileEmits, ReportInnerTabsMobileProps } from './types';

const props = defineProps<ReportInnerTabsMobileProps>();

const emit = defineEmits<ReportInnerTabsMobileEmits>();

const activeInnerTabIndex = ref(-1);

watchImmediate(() => props.activeInnerTabId, (id) => {
  if (id) {
    activeInnerTabIndex.value = props.tabs.findIndex((tab) => tab.id === id);
  }
});

function onTabChange(index: string | number): void {
  emit('select', props.tabs[Number(index)].id);
}
</script>

<template>
  <VHorizontalScrollNav v-data-qa-auto-id="'VReportInnerTabsMobile'"
    :active-index="activeInnerTabIndex"
    element-class="p-tabview-header"
  >
    <PTabs
      v-model:value="activeInnerTabIndex"
      @update:value="onTabChange"
    >
      <PTabList>
        <PTab
          v-for="(item, index) in tabs"
          :key="item.id"
          :value="index"
          :pt="{
            root: 'flex',
          }"
        >
          {{ $getTranslation(translationKey, item.shortcode) }}
        </PTab>
      </PTabList>
    </PTabs>
  </VHorizontalScrollNav>
</template>
